import { render } from "./SellerProfileBanner.vue?vue&type=template&id=2e37d21a"
import script from "./SellerProfileBanner.vue?vue&type=script&lang=js"
export * from "./SellerProfileBanner.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__